import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { IdbRepo, MemoryRepo, type TournamentRepo } from './lib/repo';
import './styles.css';

function makeRepo(): TournamentRepo {
  // Private windows in some browsers have no IndexedDB; keep the app usable.
  return typeof indexedDB === 'undefined' ? new MemoryRepo() : new IdbRepo();
}

const root = document.getElementById('root');
if (root === null) throw new Error('missing #root');
createRoot(root).render(
  <StrictMode>
    <App repo={makeRepo()} />
  </StrictMode>,
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch((e: unknown) => {
      console.warn('service worker registration failed', e);
    });
  });
}
